<template>
<section v-if="hasPermissions(['Assignment-Service-Request Read','Assignment-Service-Request Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Service Requests that have been logged into the system.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="service_requests.length && hasPermissions(['Assignment-Service-Request Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Assignment-Service-Request Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Assignment-Service-Request Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="service_requests.length && hasPermissions(['Assignment-Service-Request Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="service_requests"
                                :search="search"
                                :checkable="true"
                                :link="'/assignment-service-request/'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Service Request'"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :breadcrumb="breadcrumb"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Service Request Update'"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            :breadcrumb="breadcrumb"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'ServiceRequest',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DeletionModal,
        DinamicTable,
        DeletionMassiveModal,
        UnauthorizedComponent
    },

    data(){
        return{
            notyf,
            axios,
            child_href:         '/assignment-service-request-detail/',
            title_page:         'Service Requests',
            content_header:     this.$store.state.headers,
            rest_api:           `service_requests`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add service request',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            service_requests:   [],
            array_options:      {},
            select_ids:         [],
        }
    },

    methods:{
        
        unshift_object(new_object)
        {
            this.service_requests.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.service_requests.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index){
            this.global_index  = index
            this.single_object = this.service_requests[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.service_requests[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.service_requests = data.service_requests
            this.array_options = {
                room_id:   data.rooms,
            }
        },

        trashing(index)
        {
            this.service_requests.splice(index, 1)
        },

        
        massive_modal_delete()
        {
            this.select_ids = this.service_requests.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.service_requests.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.service_requests.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

    },

    async mounted(){
        if(this.hasPermissions(['Assignment-Service-Request Read','Assignment-Service-Request Write']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.service_requests.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },
}
</script>